<template>
    <div>
        <div class="container mx-auto page p-3" data-cy="container_profile_page">
            <div>
                <router-link to="/home" class="text-blue-500 underline font-bold" data-cy="btn_profile_home_link">Home</router-link>
            </div>
            <div class="text-lg font-bold underline mb-2" data-cy="text_profile_title">Edit Profile</div>
            <div class="mb-6" data-cy="container_profile_address_links">
                <router-link to="/address/delivery" class="bg-green-600 text-white rounded-md py-1 px-4 mr-2" data-cy="btn_profile_address_list_link">Address List</router-link>
                <router-link to="/address/tax" class="bg-yellow-500 text-white rounded-md py-1 px-4" data-cy="btn_profile_tax_address_link">Tax Address</router-link>
            </div>
            <div v-if="profile != null" data-cy="container_profile_form_wrapper">
                <FormPriofile
                        ref="form-profile"
                        v-model:setFormData="formData"
                        :modalController="modalController"
                        data-cy="component_profile_form"
                ></FormPriofile>
                <FormAddressProfile data-cy="component_profile_form_address"></FormAddressProfile>
            </div>
            <div>
                <Checkbox
                        text="Accepts Terms"
                        v-model:check="checkTerms"
                        data-cy="checkbox_profile_accept_terms"
                ></Checkbox>
            </div>
            <div class="text-center mt-4" data-cy="container_profile_save">
                <button class="bg-blue-500 text-white py-1 px-3 rounded-md"
                        @click="clickSave()" data-cy="btn_profile_save">
                    Save
                </button>
            </div>
        </div>

        <ModalMaster :controller="modalController" data-cy="component_profile_modal_master"></ModalMaster>
    </div>
</template>
<script>
// import Util from "@/helper/Utility.js";
//component
import FormPriofile from "../component/FormProfile.vue";
import FormAddressProfile from "../component/FormAddressProfile.vue";
import Checkbox from "@/components/Input/simple/Checkbox.vue";
//mixin
import AuthPageMixin from "@/mixin/AuthPageMixin.js";
import ModalMixin from "@/mixin/ModalMixin.js";
//service
import BzbsProfile from "@/core/Account/service/BzbsProfile.js";

export default {
    name: "Profile",
    mixins: [AuthPageMixin, ModalMixin],
    components: {
        FormPriofile,
        Checkbox,
        FormAddressProfile,
    },
    data: function() {
        return {
            formData: null,
            checkTerms: false,
        }
    },
    methods: {
        //#region mixin function
        onAccountInit: function() {
            this.formData = this.profile;
        },
        //#endregion mixin function

        clickSave: function() {
            let profile = this.$refs['form-profile'].submit();
            if (profile == null) {
                return;
            }
            if (!this.checkAcceptTerms()) {
                return;
            }

            this.confirmModal.clearModal()
                    .setMsg("Save comfirm?")
                    .show();
            this.confirmModal.onClickOk(async () => {

                this.loadingModal.show();
                if (await this.sendUpdateProfile(profile)) {
                    await this.getProfile();
                }
                this.loadingModal.hide();

            });
        },

        checkAcceptTerms: function() {
            if (this.checkTerms) {
                return true;
            }

            this.alertModal.clearModal()
                    .setMsg("Please accept terms")
                    .show();
            return false;
        },

        sendUpdateProfile: function(profile) {
            return new Promise((resolve) => {
                BzbsProfile.updateProfile(profile, null, null, null, null).subscribe({
                    next: (data) => {
                        console.log(data);
                        resolve(true);
                    },
                    error: (err) => {
                        resolve(false);
                        this.errorApi(err);
                    },
                });
            });
        },
        getProfile: function() {
            return new Promise((resolve) => {
                BzbsProfile.getProfile().subscribe({
                    next: (data) => {
                        this.AccountStore.methods.setProfile(data.profile);
                        // this.AccountStore.methods.setAddress(data.address);
                        // this.AccountStore.methods.setShippingAddress(data.shippingAddress);
                        resolve();
                    },
                    error: (err) => {
                        resolve();
                        this.errorApi(err);
                    }
                });
            });
        },
    },
}
</script>
<style lang="scss" scoped>

</style>
